import * as React from "react";
import Box from "@mui/material/Box";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { Login } from "../pages/Auth/Login";
import { useSelector } from "react-redux";
import { AppState } from "../redux/reducer/rootReducer";
import { AuthLayout } from "./AuthLayout";
import ProductDetailPublicView from "../compenents/products/ProductDetailPublicView";
import { AdminLogin } from "../pages/Auth/AdminLogin";
import { PageNotFound } from "../pages/NotFound/PageNotFound";
import { PartsPortal } from "../pages/ShoppingPortal/PartsPortal";
import { EmbeddedPartsProtal } from "../pages/ShoppingPortal/EmbeddedPartsProtal";
import { PartsPortalManufacturer } from "../pages/ShoppingPortal/PartsPortalManufacturer";
import { PortalCategories } from "../compenents/ShoppingPortal/PortalCategories";
import RefreshToken from "./RefreshToken";

export interface MasterLayoutProps {}

export const MasterLayout: React.FunctionComponent<MasterLayoutProps> = () => {
  const token = useSelector((state: AppState) => state.authReducer.token);
  const location = useLocation();
  let publicPage =
    location.pathname
      .toLowerCase()
      .startsWith("/ProductDetailView".toLowerCase()) ||
    location.pathname.toLowerCase().startsWith("/shoppingportal/parts") ||
    location.pathname.toLowerCase().startsWith("/shoppingportal/embeddedparts")
      ? true
      : false || location.pathname.toLowerCase().startsWith("/invalid-URL")
      ? true
      : false;
  return (
    <>
      {token && !publicPage ? (
        <Box sx={{ display: "flex", flexGrow: 1 }}>
          <AuthLayout></AuthLayout> <RefreshToken />
        </Box>
      ) : (
        <Routes>
          <Route path={"/Login"} element={<Login />}></Route>
          <Route path={"/AdminLogin"} element={<AdminLogin />}></Route>
          <Route
            path={"/ProductDetailView/:productId"}
            element={<ProductDetailPublicView />}
          ></Route>
          <Route
            path={"/ShoppingPortal/Parts"}
            element={<PartsPortal />}
          ></Route>
          <Route
            path={"/ShoppingPortal/EmbeddedParts"}
            element={<EmbeddedPartsProtal />}
          ></Route>
          <Route
            path={"/ShoppingPortal/PartsByManuacturer"}
            element={<PartsPortalManufacturer />}
          ></Route>
          <Route
            path={"/ShoppingPortal/PartsByCategory"}
            element={<PortalCategories />}
          ></Route>
          <Route path="/" element={<Navigate to={"/Login"}></Navigate>} />
          <Route
            path={"/invalid-URL"}
            element={<PageNotFound pageNotFound={false} />}
          ></Route>
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      )}
    </>
  );
};
